import React from 'react'
import './style.css'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const BugRatio = ({dashboardDataByprojId}) => {
    const bugRation = dashboardDataByprojId?.bugRatio;
    const featureBugs = dashboardDataByprojId?.featureBugs;
    const topFiveBugs = dashboardDataByprojId?.topFiveBugs;

    const formatPercent = (tick) => `${tick}%`;
    return (
        <div className='dashboard-graph'>
            <div className='line-graph'>
                <div className='graph-header'>
                    <h6>WCAG Bug Ratio</h6>
                </div>
                <div className='bar-graph'>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            width={400}
                            height={250}
                            data={bugRation}
                            margin={{
                                top: 15,
                                right: 30,
                                left: 20,
                                bottom: 45,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="scLevel" />
                            <YAxis
                                domain={[0, 100]}
                                ticks={[0, 25, 50, 75, 100]}
                                tickFormatter={formatPercent}
                            />
                            <Tooltip />
                            <Bar dataKey="percent" fill="#FF976A" barSize={40} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
            <div className='line-graph' id="featureWiseBugsTable" >
                <div className='graph-header'>
                    <h6>Feature-wise Bugs</h6>
                </div>
                <div className='bar-graph' style={{ height: '350px', overflowY: 'scroll' }} id="featureWiseBugs">
                    <div className='table-header'>
                        <table className='custom-table'>
                            <thead style={{ position: 'sticky', top: 5, zIndex:98 }}>
                                <tr>
                                    {[
                                        { header: 'Feature', key: 'feature' },
                                        { header: "Bug count", key: "count" },

                                    ].map((head, index) => (
                                        <th style={{textAlign : index === 0 ? 'left' : 'center'}} className={head?.header} key={index}>{head?.header}</th>
                                    ))}
                                </tr>

                            </thead>
                            <tbody className='bugratio-tbody'>
                                {featureBugs?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.featureName}</td>
                                        <td style={{ width: '40%' }}>{item?.count}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className='line-graph' id="top5bugsTable">
                <div className='graph-header'>
                    <h6>Top 5 Bugs</h6>
                </div>
                <div className='bar-graph' style={{ height: '350px', overflowY: 'scroll' }} id="top5bugs">
                    <div className='table-header'>
                        <table className='custom-table'>
                            <thead style={{ position: 'sticky', top: 5, zIndex:98 }}>
                                <tr>
                                    {[{ header: 'Bug', key: 'feature' },
                                    { header: "Severity", key: "severity" },
                                    ].map((head, index) => (
                                        <th className={head?.header} key={index}>{head?.header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody className='top5bugs-tbody'>
                                {topFiveBugs?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item?.summary}</td>
                                        <td style={{ width: '25%' }}>{item?.severity}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BugRatio